"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Interaction = _interopRequireWildcard(require("./Interaction.js"));

var _MapBrowserEventType = _interopRequireDefault(require("../MapBrowserEventType.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/DoubleClickZoom
 */


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */

/**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */
var DoubleClickZoom =
/** @class */
function (_super) {
  __extends(DoubleClickZoom, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function DoubleClickZoom(opt_options) {
    var _this = _super.call(this) || this;

    var options = opt_options ? opt_options : {};
    /**
     * @private
     * @type {number}
     */

    _this.delta_ = options.delta ? options.delta : 1;
    /**
     * @private
     * @type {number}
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 250;
    return _this;
  }
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */


  DoubleClickZoom.prototype.handleEvent = function (mapBrowserEvent) {
    var stopEvent = false;

    if (mapBrowserEvent.type == _MapBrowserEventType["default"].DBLCLICK) {
      var browserEvent =
      /** @type {MouseEvent} */
      mapBrowserEvent.originalEvent;
      var map = mapBrowserEvent.map;
      var anchor = mapBrowserEvent.coordinate;
      var delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
      var view = map.getView();
      (0, _Interaction.zoomByDelta)(view, delta, anchor, this.duration_);
      browserEvent.preventDefault();
      stopEvent = true;
    }

    return !stopEvent;
  };

  return DoubleClickZoom;
}(_Interaction["default"]);

var _default = DoubleClickZoom;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBR0E7O0FBQ0E7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBSkE7Ozs7O0FBTUE7Ozs7OztBQU1BOzs7OztBQUtBO0FBQUE7QUFBQTtFQUE4QkE7RUFDNUI7Ozs7O0VBR0EseUJBQVlDLFdBQVosRUFBdUI7SUFBdkIsWUFDRUMscUJBQU8sSUFEVDs7SUFHRSxJQUFNQyxPQUFPLEdBQUdGLFdBQVcsR0FBR0EsV0FBSCxHQUFpQixFQUE1QztJQUVBOzs7OztJQUlBRyxLQUFJLENBQUNDLE1BQUwsR0FBY0YsT0FBTyxDQUFDRyxLQUFSLEdBQWdCSCxPQUFPLENBQUNHLEtBQXhCLEdBQWdDLENBQTlDO0lBRUE7Ozs7O0lBSUFGLEtBQUksQ0FBQ0csU0FBTCxHQUFpQkosT0FBTyxDQUFDSyxRQUFSLEtBQXFCQyxTQUFyQixHQUFpQ04sT0FBTyxDQUFDSyxRQUF6QyxHQUFvRCxHQUFyRTs7RUFDRDtFQUVEOzs7Ozs7OztFQU1BRSxrREFBWUMsZUFBWixFQUEyQjtJQUN6QixJQUFJQyxTQUFTLEdBQUcsS0FBaEI7O0lBQ0EsSUFBSUQsZUFBZSxDQUFDRSxJQUFoQixJQUF3QkMsZ0NBQW9CQyxRQUFoRCxFQUEwRDtNQUN4RCxJQUFNQyxZQUFZO01BQUc7TUFDbkJMLGVBQWUsQ0FBQ00sYUFEbEI7TUFHQSxJQUFNQyxHQUFHLEdBQUdQLGVBQWUsQ0FBQ08sR0FBNUI7TUFDQSxJQUFNQyxNQUFNLEdBQUdSLGVBQWUsQ0FBQ1MsVUFBL0I7TUFDQSxJQUFNZCxLQUFLLEdBQUdVLFlBQVksQ0FBQ0ssUUFBYixHQUF3QixDQUFDLEtBQUtoQixNQUE5QixHQUF1QyxLQUFLQSxNQUExRDtNQUNBLElBQU1pQixJQUFJLEdBQUdKLEdBQUcsQ0FBQ0ssT0FBSixFQUFiO01BQ0EsOEJBQVlELElBQVosRUFBa0JoQixLQUFsQixFQUF5QmEsTUFBekIsRUFBaUMsS0FBS1osU0FBdEM7TUFDQVMsWUFBWSxDQUFDUSxjQUFiO01BQ0FaLFNBQVMsR0FBRyxJQUFaO0lBQ0Q7O0lBQ0QsT0FBTyxDQUFDQSxTQUFSO0VBQ0QsQ0FmRDs7RUFnQkY7QUFBQyxDQTVDRCxDQUE4QmEsdUJBQTlCOztlQThDZWYsZSIsIm5hbWVzIjpbIl9fZXh0ZW5kcyIsIm9wdF9vcHRpb25zIiwiX3N1cGVyIiwib3B0aW9ucyIsIl90aGlzIiwiZGVsdGFfIiwiZGVsdGEiLCJkdXJhdGlvbl8iLCJkdXJhdGlvbiIsInVuZGVmaW5lZCIsIkRvdWJsZUNsaWNrWm9vbSIsIm1hcEJyb3dzZXJFdmVudCIsInN0b3BFdmVudCIsInR5cGUiLCJNYXBCcm93c2VyRXZlbnRUeXBlIiwiREJMQ0xJQ0siLCJicm93c2VyRXZlbnQiLCJvcmlnaW5hbEV2ZW50IiwibWFwIiwiYW5jaG9yIiwiY29vcmRpbmF0ZSIsInNoaWZ0S2V5IiwidmlldyIsImdldFZpZXciLCJwcmV2ZW50RGVmYXVsdCIsIkludGVyYWN0aW9uIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9pbnRlcmFjdGlvbi9Eb3VibGVDbGlja1pvb20uanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=